"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldLinkBannerContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _tracking = require("../../utils/tracking");
var _actionAfterViewedComponent = require("@cian/action-after-viewed-component");
var _OldLinkBannerDesktop = require("../../components/OldLinkBannerDesktop");
var _uiKit = require("@cian/ui-kit");
var _OldLinkBannerMobile = require("../../components/OldLinkBannerMobile");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OldLinkBannerContainer = _ref => {
  let {
    url,
    placeType
  } = _ref;
  const [clicked, setClicked] = React.useState(false);
  const onClick = React.useCallback(() => {
    if (clicked) {
      return;
    }
    setClicked(true);
    (0, _tracking.trackLinkClick)();
  }, [clicked]);
  return /*#__PURE__*/React.createElement(_actionAfterViewedComponent.ActionAfterViewObserver, {
    callback: _tracking.trackBannerShow,
    percentVisible: 1,
    triggerOnce: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_OldLinkBannerDesktop.OldLinkBannerDesktop, {
    url: url,
    onClick: onClick,
    placeType: placeType
  })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true,
    phone: true
  }, /*#__PURE__*/React.createElement(_OldLinkBannerMobile.OldLinkBannerMobile, {
    url: url,
    onClick: onClick
  }))));
};
exports.OldLinkBannerContainer = OldLinkBannerContainer;